import { Modal } from 'antd'

const ANTDModal = ({ destroyOnClose = true, ...props }) => {
  return <Modal destroyOnClose={destroyOnClose} {...props} />
}

export default ANTDModal
